import Vue from 'vue'
import acefy from 'acefy'
import '@/app/app.css'
import './registerServiceWorker'

// módulos / plugins globais
import appPlugin from 'vue-plugins/appPlugin.js'
import requestsPlugin from 'vue-plugins/requestsPlugin.js'
import authPlugin from 'vue-plugins/authPlugin.js'
import dadosPluginInstaller from 'vue-plugins/dadosPluginInstaller.js'
import dialogsPlugin from 'vue-plugins/dialogsPlugin.js'
import faleConoscoPlugin from 'vue-plugins/fale-conosco/faleConoscoPlugin.js'

// satacs/app-aluno
import App from '@/App.vue'
import router from '@/router'
import getInstanceConfig from '@/instanceConfigs'
import onRouteChange from '@/onRouteChange.js'

Vue.config.productionTip = false
Vue.use(acefy)
//
Vue.use(dialogsPlugin)

Vue.filter('date', function (value) {
  if (value) {
    value = value.split('T')[0]
    value = value.split('-')
    value.reverse()
    value = value.join('/')
    return value
  }
})

const appConfig = {
  name: 'Ambiente de Estudo - SATACS',
  build: '19.06.031'
}
getInstanceConfig(appConfig).then(function (instance) {
  appConfig.instance = instance
  /*
   não sei se eu ainda uso appConfig.api em algum lugar
   mas vou manter por segurança
  */
  Vue.use(appPlugin, appConfig)
  Vue.use(requestsPlugin, {
    name: '$requests',
    api: instance.api
  })
  Vue.use(authPlugin, {
    api: instance.api,
    endpoints: {
      login: '/LOGIN/USUARIO',
      resetPassword: '/LOGIN/USUARIO/RESET',
      changePassword: '/LOGIN/USUARIO/CHANGE'
    },
    authConfig: {
      passwordEncoding: 'md5',
      payloadConfig: 'user'
    }
  })
  Vue.use(faleConoscoPlugin, {
    name: '$faleConosco',
    url: instance.api + '/fale-conosco',
    title: 'Dúvidas ou sugestões?',
    subTitle: 'Fale Conosco'
  })
  const $dados = {
    ALUNO: {},
    CURSOS: [],
    MATRICULAS: [],
    BLOCOS: [],
    RODADAS: [],
    RODADA: {},
    ASSUNTOS: {},
    APOSTILA: {},
    DISPOSITIVOSLEGAIS: [],
    MATRICULA: {},
    CURSO: {},
    BLOCO: {},
    PERGUNTA: {},
    RESULTADO: {},
    RESPONDIDA: false,
    RESPOSTA: 0,
    pages: [
      {
        name: 'MODULOS',
        title: 'Módulos'
      },
      {
        name: 'ASSUNTOS',
        title: 'Assuntos'
      },
      {
        name: 'APOSTILA',
        title: 'Apostila'
      },
      {
        name: 'DISPOSITIVOSLEGAIS',
        title: 'Dispositivos Legais'
      },
      {
        name: 'COMPLETE',
        title: 'Complete'
      },
      {
        name: 'ASSERTIVAS',
        title: 'Verdadeiro ou Falso'
      },
      {
        name: 'QUESTOES',
        title: 'Questões'
      }
    ]
  }
  dadosPluginInstaller.install('$dados', $dados)

  /* eslint-disable no-new */
  new Vue({
    router: router,
    el: '#app',
    template: '<App/>',
    components: { App: App },
    created: function () {
      this.updateXToken()
      onRouteChange(this, true)
      var $dados = this.$dados
      this.$faleConosco.onGetScope = function () {
        return {
          href: window.location.href,
          CURSO: $dados.CURSO,
          BLOCO: $dados.BLOCO,
          PERGUNTA: $dados.PERGUNTA,
          RESULTADO: $dados.RESULTADO
        }
      }
    },
    data: function () {
      return {
        lastID: 0
      }
    },
    methods: {
      home: function (force) {
        if (this.$auth.logged && (force || (this.$route.path.toLowerCase().indexOf('/aluno') < 0))) {
          location.hash = '#/aluno/' + this.$auth.user.id
        } else if (!this.$auth.logged) {
          location.hash = '#/'
        }
      },
      updateXToken: function () {
        this.home()
        this.$requests.setHeader({
          name: 'X-TOKEN',
          value: this.$auth.token
        })
      }
    },
    watch: {
      '$auth.logged': {
        handler: function (logged) {
          this.updateXToken()
        },
        deep: true
      },
      '$route': {
        handler: function ($route) {
          if (!this.$auth.logged) {
            this.$dados.clear()
            return
          } else if (this.lastID && (this.lastID !== $route.params.idaluno)) {
            this.$dados.clear()
          }
          this.lastID = $route.params.idaluno
          onRouteChange(this)
        },
        deep: true
      },
      '$requests.response': {
        handler: function (response) {
          if (response.status === 401) {
            location.hash = '#/'
          } else if (!response.data.ok) {
            this.home(true)
            this.$dados.clear()
            const msg = (response.data.message || 'erro desconhecido. Solicitação não concluída')
            this.$dialogs.snackbar.showMessage(msg)
          }
        },
        deep: true
      }
    }
  })
})
